import React, { ReactNode, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import { PRODUCT_CLASS_CAMPAIGN } from '../../store/constants';
import ProductSalesStateDescriptionPopup from './ProductSalesStateDescriptionPopup';
import { ProductMetaData } from '../../../models/Product';
import { useTranslation } from 'react-i18next';
import { mapSalesStatus } from '../common/translationMappers/salesStatusMapper';

const StReleaseDateParagraph = styled.p`
    position: relative;
`;

type Props = {
    readonly product: Pick<ProductMetaData, 'salesStatus' | 'productClass' | 'releaseDate'>;
    readonly label?: string;
};

export const ProductReleaseDate = ({ label, product }: Props) => {
    const [showPreOrderDescription, setShowPreOrderDescription] = useState(false);
    const { t } = useTranslation();
    let releaseDateStr: string | null = null;
    try {
        releaseDateStr = t('dateFormat.dateWithShortMonth', {
            val: new Date(product.releaseDate ?? 0)
        });
    } catch (e) {
        if (e instanceof TypeError) {
            return null;
        }
        throw e;
    }
    const releaseDate = new Date(product.releaseDate!);
    const today = new Date();

    let mouseEnterOpenDescription: (() => void) | undefined;
    let mouseLeaveCloseDescription: (() => void) | undefined;
    let salesStateDescriptionContainer: ReactNode = null;
    let dateDescr: string | null = null;
    const isDelayed = releaseDate <= today;

    const isCampaign = product.productClass === PRODUCT_CLASS_CAMPAIGN;

    if (!isCampaign && !isEmpty(product.salesStatus)) {
        const salesStatusMappedKey = mapSalesStatus(product.salesStatus!.key!);
        dateDescr = t(`components.salesStatus.${salesStatusMappedKey}.label`, {
            defaultValue: salesStatusMappedKey === 'available' ? '' : product.salesStatus!.value
        });
        const description = t(`components.salesStatus.${salesStatusMappedKey}.description`, {
            defaultValue: ''
        });

        if (!isEmpty(description)) {
            mouseEnterOpenDescription = () => {
                setShowPreOrderDescription(true);
            };

            mouseLeaveCloseDescription = () => {
                setShowPreOrderDescription(false);
            };

            if (showPreOrderDescription) {
                salesStateDescriptionContainer = <ProductSalesStateDescriptionPopup description={description} />;
            }
        }

        if (!isEmpty(dateDescr) && salesStatusMappedKey !== 'available' && isDelayed) {
            dateDescr = t('components.salesStatus.delayed');
        }
    }

    return (
        <StReleaseDateParagraph
            className="prd-release-date-ln"
            onMouseEnter={mouseEnterOpenDescription}
            onMouseLeave={mouseLeaveCloseDescription}
            style={{ display: 'block' }}
        >
            {label ? `${label} ` : ''}
            {releaseDateStr} {dateDescr}
            {salesStateDescriptionContainer}
        </StReleaseDateParagraph>
    );
};
